import React from "react";
import Box from "@mui/material/Box";
import { HashLink } from "react-router-hash-link";
const Page404 = () => {
  return (
    <Box
      sx={{
        pt: 10,
        py: 10,
        fontSize: "53px",
        textAlign: "center",
        lineHeight: "120%",
      }}
    >
      <img src="/img/undraw_traveling_re_weve.svg" width="300" alt="" />
      <br />
      Oops,
      <Box sx={{ fontSize: "30px" }}>Page is not found.</Box>
      <Box sx={{ fontSize: "20px" }}>Sorry, we couldn't find this page. </Box>
      <Box
        sx={{
          width: { md: 1 / 5, sm: 1 / 2 },
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        <HashLink to="/">
          <button className="custom_btn">Go Back to home</button>
        </HashLink>
      </Box>
    </Box>
  );
};

export default Page404;
